import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dashboard-wrapper"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = ["id", "name", "application", "applicant", "showToggle", "documentTypeId"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 1,
  class: "uploaded-files"
}
const _hoisted_9 = { class: "filetype" }
const _hoisted_10 = { class: "column-left" }
const _hoisted_11 = { class: "column-right" }
const _hoisted_12 = { class: "file" }
const _hoisted_13 = { class: "filename" }
const _hoisted_14 = { class: "column-right" }

import { ref, computed, reactive } from "vue";
import { useStore } from "vuex";
import UppyUploaderWrapper from "@/components/shared/UppyUploaderWrapper.vue";
import { DocumentEntityTypes } from "@/models/enums";


export default /*@__PURE__*/_defineComponent({
  __name: 'UppyUploader',
  props: {
  application: { type: Object },
  applicant: { type: Object },
  dashboardOpen: { type: Boolean },
  documentTypeId: { type: Number },
  files: { type: Array },
  inline: { type: Boolean, default: true },
  label: { type: String, required: false },
  name: { type: String, required: false },
  showToggle: { type: Boolean },
  stipulationId: { type: Number, required: false },
  user: { type: Object },
  height: { type: Number, default: 400 },
  uploadSuccess: { type: Boolean, required: false },
  uploadComplete: { type: Boolean, required: false },
  entityTypeId: { type: Number },
},
  emits: ["toggleDashboard", "uploadSuccess", "errorMessageUpdated"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const root = ref(null) as any;

const uppyId = computed<string>(() => `uppy_${props?.name}`);
const progressBarId = computed<string>(() => `uppy_${props?.name}_progressBar`);
const statusBarId = computed<string>(() => `uppy_${props?.name}_statusBar`);
const oidcUser = computed(() => store.getters["oidcStore/oidcUser"]);
const contactUs = computed(() => store.getters["contactUs"]);

const uploadedFiles = ref([] as any[]);
const fileUploadComplete = ref<undefined | boolean>(undefined);
const showInlineDashboard = ref<undefined | boolean>(undefined);
const errorMessageText = ref<string>("");

const metadata = reactive({
  entityId: props?.application?.id || props?.applicant?.applicationId,
  personId: props?.applicant?.id,
  entityTypeId: DocumentEntityTypes.Application,
  userId: oidcUser?.value?.sub,
  documentTypeId: props?.documentTypeId || 23,
  applicantVisibility: true,
  stipulationId: props?.stipulationId,
});

function setErrorMessage(event: any) {
  errorMessageText.value = event.errorMessage || "";
}

function handleUploadComplete(event: any) {
  uploadedFiles.value = event.successful;
  fileUploadComplete.value = true;
  showInlineDashboard.value = false;

  const file = event?.successful[0];
  if (file) {
    emit("uploadSuccess", { result: true });
  }
}

function toggleDashboard() {
  showInlineDashboard.value = !showInlineDashboard.value;
  const el = root.value as HTMLElement;
  el.scrollTop = 0;
  emit("toggleDashboard", true);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(UppyUploaderWrapper, {
    uppyId: uppyId.value,
    metadata: metadata,
    height: __props.height,
    "document-type-id": __props.documentTypeId,
    "upload-success": __props.uploadSuccess,
    "upload-complete": __props.uploadComplete,
    "contact-us": contactUs.value,
    onErrorMessageUpdate: setErrorMessage,
    onUploadComplete: handleUploadComplete
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "root",
        ref: root,
        class: "file-upload",
        "on:toggleDashboard": toggleDashboard
      }, [
        (uploadedFiles.value?.length <= 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (__props.showToggle && !showInlineDashboard.value && !fileUploadComplete.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.label), 1),
                      _createElementVNode("div", { class: "col end" }, [
                        _createElementVNode("button", {
                          onClick: toggleDashboard,
                          class: "btn-primary btn btn-primary btn-primary"
                        }, [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("span", { class: "button-text" }, "UPLOAD", -1)
                        ]))])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", {
                class: "drag-drop-area",
                id: uppyId.value,
                name: __props.name,
                application: __props.application,
                applicant: __props.applicant,
                showToggle: __props.showToggle,
                documentTypeId: __props.documentTypeId
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(__props.label), 1)
                ])
              ], 8, _hoisted_5), [
                [_vShow, showInlineDashboard.value === true]
              ])
            ]))
          : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "icon complete",
                    icon: ['fas', 'circle-check']
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", null, " " + _toDisplayString(__props.label), 1)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploadedFiles.value, (file, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "uploaded-file",
                  key: index
                }, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "column-left" }, null, -1)),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("p", null, _toDisplayString(file?.name), 1)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ], 512)), [
              [_vShow, uploadedFiles.value && uploadedFiles.value?.length > 0]
            ])
      ], 544)
    ]),
    _: 1
  }, 8, ["uppyId", "metadata", "height", "document-type-id", "upload-success", "upload-complete", "contact-us"]))
}
}

})